import { PieceType as P } from '../../types';

/** First-version draft priors from Dion's review; no claim of learned strengths. */
export function draftScore(piece:P, opponents:P[], own:P[]):number {
  const count=(types:P[])=>opponents.filter(p=>types.includes(p)).length;
  let score=100;
  if(piece===P.Crane) score+=12*count([P.Fungi,P.Monkey,P.Goat])-14*count([P.Bear,P.Wolf,P.Rhino]);
  if(piece===P.Octopus) score+=12*count([P.Bear,P.Wolf,P.Snake,P.Frog,P.Crane])-12*count([P.Tree,P.Fungi]);
  if([P.Tree,P.Fungi].includes(piece)) score+=18*count([P.Octopus]);
  if([P.Wolf,P.Bear].includes(piece)) score+=16*count([P.Rhino]);
  if(piece===P.Monkey && own.includes(P.Tree)) score+=38;
  if(piece===P.Tree && own.includes(P.Monkey)) score+=38;
  if(piece===P.Snake && own.includes(P.Frog)) score+=18;
  if(piece===P.Frog && own.includes(P.Snake)) score+=18;
  if(piece===P.Rhino && own.some(p=>[P.Penguin,P.Frog].includes(p))) score+=20;
  if(piece===P.Frog && own.includes(P.Octopus)) score-=18;
  if(piece===P.Octopus && own.includes(P.Frog)) score-=18;
  // King is selected separately. A drafted Penguin is a non-king, where its utility is limited.
  if(piece===P.Penguin) score-=40;
  // Virus needs an expendable host and targets worth chaining through.
  if(piece===P.Virus) score+=own.length>=2 && opponents.length>=2 ? 5 : -25;
  return score;
}
export function selectAstraPiece(available:P[],opponents:P[],own:P[]):P {
  return [...available].sort((a,b)=>draftScore(b,opponents,own)-draftScore(a,opponents,own))[0];
}
